export const DEALATTRIBUTE_PERSONAL_URL = '/api/dealattribute/personal/';
export const ANON_USER_QUERY_PARAM = 'is_authenticated=false';
